import { Box, useTheme, Button, useMediaQuery } from "@mui/material";
import Header from "../../components/Header";
import ProduccionPie from "../../components/ProduccionPie";
import PieChart from "../../components/PieChart";
import InterfoliadoTurnoPie from "../../components/InterfoliadoTurnoPie";
import { useState, useEffect, useRef, useContext} from "react";
import { getDatoClasificacion, getDatoInterfoleacion, getDatoReporte } from "../../services/graficos.services";
import { format } from "date-fns";
import { DataGrid } from "@mui/x-data-grid";
import { tokens } from "../../theme";
import html2canvas from "html2canvas";
import jsPDF from "jspdf";
import autoTable from "jspdf-autotable";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import dayjs from "dayjs";
import { DatePicker } from "@mui/x-date-pickers/DatePicker";
import "../../css/styles.css"
import useFechaSeleccionada from "../../customHooks/parseFechaHook";
import useMesSeleccionada from "../../customHooks/parseMesHook";
import ModalCharge from "../../modal/modalCharge";


const RGraficos = () => {
  const [isLoading, setIsLoading] = useState(false);
  const [data, setData] = useState([]);
  const [dataC, setDataC] = useState([]);
  const [dataInterfoleacion, setDataInterfoleacion] = useState([]);
  const [dataInterfoleacionRaw, setDataInterfoleacionRaw] = useState([]);
  const [startDate, setStartDate] = useState(dayjs()); // Iniciar con null
  const [endDate, setEndDate] = useState(dayjs()); // Iniciar con null
  const theme = useTheme();
  const isDesktop = useMediaQuery(theme.breakpoints.up("md"));
  const colors = tokens(theme.palette.mode);
  const chartRef = useRef();
  const secondChartRef = useRef();
  const thirdChartRef = useRef();
  const { fechaSeleccionada, setFechaSeleccionada } = useFechaSeleccionada();
  // const { fechaInicio, setFechaInicio } = useMesSeleccionada();
  // const { fechaFin, setFechaFin } = useMesSeleccionada();
  // const [elVerdadero, setElVerdadero] = useMesSeleccionada();
  const {
    fechaInicio, 
    setFechaInicio,
    fechaFin,
    setFechaFin,
    elVerdadero
} = useMesSeleccionada();


  const [fechas, setfechas] = useState({
    fecha:""
  });
  const fechasxd = {
    fechaInicio: fechaInicio,
    fechaFin: fechaFin,
  }

  const fixedCol = (width) => ({ width, minWidth: width, maxWidth: width });

  const columns = [
    { field: "id_producto", headerName: "ID Producto", ...fixedCol(isDesktop ? 300 : 100) },
    { field: "tipo_vidrio", headerName: "Tipo de Vidrio", ...fixedCol(isDesktop ? 1000 : 220) },
    { field: "total_cantidad", headerName: "Cantidad", ...fixedCol(isDesktop ? 400 : 90) },
    { field: "turno", headerName: "Turno", ...fixedCol(isDesktop ? 400 : 120) },
    { field: "fecha", headerName: "Fecha", ...fixedCol(isDesktop ? 400 : 120) },
  ];

  const columnsC = [
    { field: "id_producto", headerName: "ID Producto", ...fixedCol(isDesktop ? 150 : 100) },
    { field: "cod", headerName: "Tipo de Vidrio", ...fixedCol(isDesktop ? 700 : 200) },
    { field: "serie", headerName: "Serie", ...fixedCol(isDesktop ? 300 : 80) },
    { field: "total_cantidad", headerName: "Cantidad", ...fixedCol(isDesktop ? 220 : 90) },
    { field: "clasificacion", headerName: "Clasificacion", ...fixedCol(isDesktop ? 300 : 110) },
    { field: "obs", headerName: "Defecto", ...fixedCol(isDesktop ? 300 : 120) },
    { field: "motivo", headerName: "Motivo", ...fixedCol(isDesktop ? 200 : 150) },
    { field: "turnos", headerName: "Turno", ...fixedCol(isDesktop ? 200 : 110) },
    {
      field: "fecha",
      headerName: "Fecha",
      ...fixedCol(isDesktop ? 130 : 110),
      renderCell: (params) =>
        params.value ? format(new Date(params.value), "dd/MM/yyyy") : "",
    },
  ];

  const columnsI = [
    { field: "id_producto", headerName: "ID Producto", ...fixedCol(isDesktop ? 200 : 100) },
    { field: "cod", headerName: "Tipo de Vidrio", ...fixedCol(isDesktop ? 800 : 200) },
    { field: "cantidad", headerName: "Cantidad", ...fixedCol(isDesktop ? 200 : 90) },
    { field: "clasificacion", headerName: "Clasificacion", ...fixedCol(isDesktop ? 300 : 110) },
    { field: "obs", headerName: "Defecto", ...fixedCol(isDesktop ? 300 : 120) },
    { field: "motivo", headerName: "Motivo", ...fixedCol(isDesktop ? 300 : 150) },
    { field: "turno", headerName: "Turno", ...fixedCol(isDesktop ? 200 : 110) },
    { field: "fecha", headerName: "Fecha", ...fixedCol(isDesktop ? 200 : 110) },
  ];


  useEffect(() => {
    if (startDate) {
      const formattedStartDate = dayjs(startDate).format("DD/MM/YYYY");
      setFechaInicio(dayjs(startDate)); // Pasamos dayjs directamente, no la fecha formateada
    }
  
    if (endDate) {
      const formattedEndDate = dayjs(endDate).format("DD/MM/YYYY");
      setFechaFin(dayjs(endDate)); // Igual que arriba
    }
  }, [startDate, endDate]);
  
  
  
  useEffect(() => {
    const fetchData = async () => {
      const response = await getDatoReporte(elVerdadero);
      const groupedData = groupAndSummarizeData(response);
      // console.log("groupedData", groupedData);
      setData(groupedData);
    };
    fetchData();
  }, [elVerdadero]);

  
  useEffect(() => {
    const fetchDataInterfoleacion = async () => {
      const response = await getDatoInterfoleacion(elVerdadero);
      // console.log("response interfoliacion", response);
      setDataInterfoleacionRaw(Array.isArray(response) ? response : []);

      const groupedData = groupAndSumInterfoliacion(response);
      // console.log("groupedData", groupedData);
       setDataInterfoleacion(groupedData);
    };
    fetchDataInterfoleacion();
  }, [elVerdadero]);


  useEffect(() => {
    const fetchData = async () => {
      const response = await getDatoClasificacion(elVerdadero);
      // const groupedData = groupAndSummarizeData(response);
      setDataC(response);
    };
    fetchData();
  }, [elVerdadero]);



  const loadImage = (src) => {
    return new Promise((resolve) => {
      const img = new Image();
      img.src = src;
      img.onload = () => resolve(img);
    });
  };

  const groupAndSumInterfoliacion = (data) => {
    const groupData = {};
  
    data.forEach((item) => {
      // Incluimos la fecha formateada en la clave de agrupación
      const key = `${item.id_producto}-${item.clasificacion}-${item.fecha}`;
  
      if (!groupData[key]) {
        groupData[key] = {
          id_producto: item.id_producto,
          clasificacion: item.clasificacion,
          cod: item.cod,
          cantidad: 0,
          fecha: item.fecha, // usamos la fecha formateada
          obs: item.obs,
          turno: item.turno,
          motivo: item.motivo
        };
      }
  
      groupData[key].cantidad += parseInt(item.cantidad, 10) || 0;
    });
  
    // Devolvemos los valores agrupados en forma de array
    return Object.values(groupData);
  };
  



  const groupAndSummarizeData = (data) => {
    const groupedData = {};
  
    data.forEach((item) => {
      const turno =
        item.id_horario === 3
          ? "Primer Turno"
          : item.id_horario === 4
          ? "Segundo Turno"
          : item.id_horario === 12
          ? "Tercer Turno"
          : "Turno Desconocido";
  
      const fechaFormateada = new Date(item.fecha).toLocaleDateString('es-ES', {
        day: '2-digit',
        month: '2-digit',
        year: 'numeric'
      });
  
      const key = `${item.id_producto}-${turno}-${fechaFormateada}`;
  
      if (!groupedData[key]) {
        groupedData[key] = {
          id_producto: item.id_producto,
          tipo_vidrio: item.cod,
          total_cantidad: 0,
          turno: turno,
          fecha: fechaFormateada,
        };
      }
  
      // Sumar la cantidad de cada producto
      groupedData[key].total_cantidad += parseInt(item.total_cantidad || item.cantidad || 1, 10);
    });
  
    // Convertimos a array y ordenamos por fecha
    return Object.values(groupedData).sort((a, b) => {
      const dateA = a.fecha.split('/').reverse().join('-');
      const dateB = b.fecha.split('/').reverse().join('-');
      return new Date(dateA) - new Date(dateB);
    });
  };
  


  const calcularTotalProducido = () => {
    return data.reduce((acc, curr) => acc + curr.total_cantidad, 0);
  };

  const calcularTotalDefectos = () => {
    return dataC.reduce((acc, curr) => acc + (parseInt(curr.total_cantidad, 10) || 0), 0);
  };

  const calcularTotalInterfoliados = () => {
    return dataInterfoleacion.reduce((acc, curr) => acc + (parseInt(curr.cantidad, 10) || 0), 0);
  };

  // Extrae largo (cm) y tipo de PVB desde el nombre del producto
  // Formato esperado: "... 321x240-PVBINC ARQ.38"
  const parsePvbFromProducto = (tipovid) => {
    if (!tipovid) return null;
    const match = tipovid.match(/(\d+)x\d+-(.+)$/i);
    if (!match) return null;
    return {
      largo_m: parseInt(match[1], 10) / 100,
      pvb_tipo: match[2].trim(),
    };
  };

  const calcularResumenPvb = () => {
    const resumen = {};
    data.forEach((row) => {
      const parsed = parsePvbFromProducto(row.tipo_vidrio);
      if (!parsed) return;
      const { largo_m, pvb_tipo } = parsed;
      const cantidad = parseInt(row.total_cantidad, 10) || 0;
      const metros = largo_m * cantidad;
      if (!resumen[pvb_tipo]) resumen[pvb_tipo] = { pvb_tipo, cantidad_chapas: 0, metros_totales: 0 };
      resumen[pvb_tipo].cantidad_chapas += cantidad;
      resumen[pvb_tipo].metros_totales += metros;
    });
    return Object.values(resumen);
  };

  const calcularTotalMetrosPvb = () => {
    return calcularResumenPvb().reduce((acc, r) => acc + r.metros_totales, 0);
  };

  const normalizeTurnoResumen = (turno) => {
    if (turno === 3 || turno === "3") return "1er Turno";
    if (turno === 4 || turno === "4") return "2do Turno";
    if (turno === 12 || turno === "12") return "3er Turno";

    const text = String(turno || "").toLowerCase();
    if (text.includes("primer")) return "1er Turno";
    if (text.includes("segundo")) return "2do Turno";
    if (text.includes("tercer")) return "3er Turno";
    return "Turno no definido";
  };

  const buildResumenInterfoliadoByColar = (rows) => {
    const paquetesPorColar = {};

    rows.forEach((item) => {
      const producto = item.cod || item.tipo_vidrio || item.descripcion || "Producto no definido";
      const turno = normalizeTurnoResumen(item.turno ?? item.turnos ?? item.id_horario);
      const colar = String(item.colar ?? "").trim();
      const colarNormalized = colar.toLowerCase();

      if (!colar || colarNormalized === "null" || colarNormalized === "undefined") return;

      const cantidad = parseInt(item.cantidad ?? item.total_cantidad ?? 0, 10) || 0;
      const key = `${turno}||${producto}||${colar}`;

      if (!paquetesPorColar[key]) {
        paquetesPorColar[key] = {
          turno,
          producto,
          colar,
          cantidadPaquete: 0,
        };
      }

      paquetesPorColar[key].cantidadPaquete += cantidad;
    });

    const resumen = {};

    Object.values(paquetesPorColar).forEach((pkg) => {
      const key = `${pkg.turno}||${pkg.producto}||${pkg.cantidadPaquete}`;

      if (!resumen[key]) {
        resumen[key] = {
          turno: pkg.turno,
          producto: pkg.producto,
          paquetes: 0,
          cantidadPaquete: pkg.cantidadPaquete,
          cantidadTotal: 0,
        };
      }

      resumen[key].paquetes += 1;
      resumen[key].cantidadTotal += pkg.cantidadPaquete;
    });

    const orderTurno = { "1er Turno": 1, "2do Turno": 2, "3er Turno": 3, "Turno no definido": 99 };

    return Object.values(resumen).sort((a, b) => {
      const turnoDiff = (orderTurno[a.turno] || 99) - (orderTurno[b.turno] || 99);
      if (turnoDiff !== 0) return turnoDiff;

      const productDiff = a.producto.localeCompare(b.producto);
      if (productDiff !== 0) return productDiff;

      return b.cantidadPaquete - a.cantidadPaquete;
    });
  };

  const handleGenerate = async () => {
    setIsLoading(true);
    await new Promise((resolve) => setTimeout(resolve, 500));

    // Crear un nuevo documento PDF
    const pdf = new jsPDF("portrait", "pt", "a4");

    // Cargar el logo
    const logo = await loadImage('../assets/dracenaC.png');
    const logoWidth = 200;
    const logoHeight = 80;
    const spacing = 90;
    const paddingBottom = 30;
    const paddingTop = 30;

    // Agregar logo y título principal
    pdf.addImage(logo, 'PNG', 10, 10, logoWidth, logoHeight);
    pdf.setFontSize(20);
    pdf.text("Reportes de Producción", 10 + logoWidth + spacing, 30 + paddingTop);

    // Capturar el gráfico sin leyenda
    const chartCanvas = await html2canvas(chartRef.current, {
        useCORS: true,
        scale: 2,
        x: 0,
        y: 60,
        width: chartRef.current.offsetWidth,
        height: chartRef.current.offsetHeight,
    });
    const chartImage = chartCanvas.toDataURL("image/png");

    const secondChartCanvas = await html2canvas(secondChartRef.current, {
        useCORS: true,
        scale: 2,
        x: 0,
        y: 60,
        width: secondChartRef.current.offsetWidth,
        height: secondChartRef.current.offsetHeight,
    });
    const secondChartImage = secondChartCanvas.toDataURL("image/png");

    const thirdChartCanvas = await html2canvas(thirdChartRef.current, {
      useCORS: true,
      scale: 2,
      x: 0,
      y: 60,
      width: thirdChartRef.current.offsetWidth,
      height: thirdChartRef.current.offsetHeight,
    });
    const thirdChartImage = thirdChartCanvas.toDataURL("image/png");

    const pdfWidth = pdf.internal.pageSize.getWidth();
    const horizontalMargin = 10;
    const chartGap = 10;
    const chartImageWidth = (pdfWidth - horizontalMargin * 2 - chartGap * 2) / 3;
    const chartImageHeight = (chartCanvas.height / chartCanvas.width) * chartImageWidth;
    const chartTitleY = 96;
    const chartY = 108;

    pdf.setFontSize(10);
    pdf.setFont("helvetica", "bold");
    pdf.text("Cantidad Producida", horizontalMargin + chartImageWidth / 2, chartTitleY, { align: "center" });
    pdf.text("Cantidad Producida por Turno", horizontalMargin + chartImageWidth + chartGap + chartImageWidth / 2, chartTitleY, { align: "center" });
    pdf.text("Interfoliados por Turno", horizontalMargin + (chartImageWidth + chartGap) * 2 + chartImageWidth / 2, chartTitleY, { align: "center" });
    pdf.setFont("helvetica", "normal");

    pdf.addImage(chartImage, "PNG", horizontalMargin, chartY, chartImageWidth, chartImageHeight);
    pdf.addImage(secondChartImage, "PNG", horizontalMargin + chartImageWidth + chartGap, chartY, chartImageWidth, chartImageHeight);
    pdf.addImage(thirdChartImage, "PNG", horizontalMargin + (chartImageWidth + chartGap) * 2, chartY, chartImageWidth, chartImageHeight);

    const producedTitleY = chartY + chartImageHeight + 40;

    // Agregar título "Laminados Producidos"
    pdf.setFontSize(14);
    pdf.text("Laminados Producidos", 40, producedTitleY);

    const tableData = data.map((row) => [
      row.tipo_vidrio,
      row.total_cantidad,
      row.turno,
      // row.fecha ? format(new Date(row.fecha), "dd/MM/yyyy") : "",
      row.fecha,

    ]);
    const tableColumns = ["Tipo de Vidrio", "Cantidad", "Turno", "Fecha"];
    const tableOptions = {
      startY: producedTitleY + 15,
      styles: {
        cellPadding: 3,
        fontSize: 11,
        overflow: 'linebreak',
        align: 'center',
        valign: 'middle',
      },
      columnStyles: {
        0: { cellWidth: 250 },
        1: { cellWidth: 70 },
        2: { cellWidth: 70 },
        3: { cellWidth: 130 },
      },
    };
    autoTable(pdf, {
      head: [tableColumns],
      body: tableData,
      ...tableOptions,
    });

    const totalProducido = calcularTotalProducido();
    const totalProduccionY = pdf.lastAutoTable.finalY + 30;
    pdf.setFontSize(14);
    pdf.text(`Total Producción: ${totalProducido}`, 40, totalProduccionY);

    if (dataC.length > 0) {
    // Agregar título "Productos Defectuosos"
    const defectuososTitleY = totalProduccionY + 40;
    pdf.setFontSize(14);
    pdf.text("Productos Defectuosos", 40, defectuososTitleY);

    const defectuososData = dataC.map((row) => [
      row.cod,
      row.serie,
      row.clasificacion,
      row.obs,
      row.motivo,
      row.turnos,
    ]);
    const defectuososColumns = ["Tipo de Vidrio", "Serie", "Tipo", "Defecto", "Motivo", "Turno"];
    const defectuososOptions = {
      startY: defectuososTitleY + 15,
      styles: {
        cellPadding: 3,
        fontSize: 10,
        overflow: 'linebreak',
        align: 'center',
        valign: 'middle',
      },
      columnStyles: {
        0: { cellWidth: 150 },
        1: { cellWidth: 60 },
        2: { cellWidth: 60 },
        3: { cellWidth: 80 },
        4: { cellWidth: 100 },
        5: { cellWidth: 90 },
      },
    };
    autoTable(pdf, {
      head: [defectuososColumns],
      body: defectuososData,
      ...defectuososOptions,
    });
  }

    const totalDefectuosos = calcularTotalDefectos();
    const totalDefectuososY = pdf.lastAutoTable.finalY + 50;
    pdf.setFontSize(14);
    pdf.text(`Total Defectuosos: ${totalDefectuosos}`, 40, totalDefectuososY);

   

    pdf.addPage();

    const interfoliadaTitleY = 40;
    pdf.setFontSize(14);
    pdf.text("Productos Interfoliados", 40, interfoliadaTitleY);

    const interfoliadaData = dataInterfoleacion.map((row) => [
      row.cod,
      row.cantidad,
      row.clasificacion,
      row.obs,
      row.turno,
      row.fecha,
    ]);
    const interfoliadaColumns = ["Tipo de Vidrio", "Cantidad", "Clasificación", "Defecto", "Turno", "Fecha"];
    autoTable(pdf, {
      head: [interfoliadaColumns],
      body: interfoliadaData,
      startY: interfoliadaTitleY + 15,
      margin: { top: 40, right: 40, bottom: 40, left: 40 },
      styles: {
        cellPadding: 3,
        fontSize: 10,
        overflow: 'linebreak',
        align: 'center',
        valign: 'middle',
      },
      columnStyles: {
        0: { cellWidth: 130 },
        1: { cellWidth: 60 },
        2: { cellWidth: 80 },
        3: { cellWidth: 90 },
        4: { cellWidth: 70 },
        5: { cellWidth: 100 },
      },
      pageBreak: 'auto',
      rowPageBreak: 'avoid',
    });

    const pageHeight = pdf.internal.pageSize.getHeight();
    let totalInterfoliadaY = pdf.lastAutoTable.finalY + 30;
    if (totalInterfoliadaY > pageHeight - 30) {
      pdf.addPage();
      totalInterfoliadaY = 40;
    }
    pdf.setFontSize(14);
    pdf.text(`Total Interfoliada: ${calcularTotalInterfoliados()}`, 40, totalInterfoliadaY);

    const resumenInterfoliado = buildResumenInterfoliadoByColar(dataInterfoleacionRaw);
    pdf.addPage();

    const resumenTitleY = 40;
    pdf.setFontSize(14);
    pdf.text("Resumen de Interfoliados por Colar y Turno", 40, resumenTitleY);

    const resumenBody = resumenInterfoliado.map((row) => [
      row.turno,
      row.producto,
      row.paquetes,
      row.cantidadPaquete,
      row.cantidadTotal,
    ]);

    autoTable(pdf, {
      head: [["Turno", "Producto", "Paquetes", "Cantidad por paquete", "Cantidad total"]],
      body: resumenBody,
      startY: resumenTitleY + 15,
      margin: { top: 40, right: 40, bottom: 40, left: 40 },
      styles: {
        cellPadding: 3,
        fontSize: 9,
        overflow: "linebreak",
        valign: "middle",
      },
      columnStyles: {
        0: { cellWidth: 75, halign: "center" },
        1: { cellWidth: 255, halign: "left" },
        2: { cellWidth: 60, halign: "center" },
        3: { cellWidth: 90, halign: "center" },
        4: { cellWidth: 80, halign: "center" },
      },
      pageBreak: "auto",
      rowPageBreak: "avoid",
    });

    const totalPaquetes = resumenInterfoliado.reduce((acc, row) => acc + row.paquetes, 0);
    let totalResumenY = pdf.lastAutoTable.finalY + 20;
    if (totalResumenY > pageHeight - 30) {
      pdf.addPage();
      totalResumenY = 40;
    }
    pdf.setFontSize(12);
    pdf.text(`Total de paquetes (colares): ${totalPaquetes}`, 40, totalResumenY);

    // --- Sección PVB ---
    const resumenPvb = calcularResumenPvb();
    if (resumenPvb.length > 0) {
      pdf.addPage();
      pdf.setFontSize(14);
      pdf.text("Consumo de PVB", 40, 40);
      pdf.setFontSize(10);
      pdf.text(
        `Período: ${elVerdadero?.fechaInicio ?? "-"} al ${elVerdadero?.fechaFin ?? "-"}`,
        40, 60
      );

      autoTable(pdf, {
        head: [["Tipo PVB", "Chapas producidas", "Metros lineales"]],
        body: resumenPvb.map((r) => [
          r.pvb_tipo,
          r.cantidad_chapas,
          r.metros_totales.toFixed(2) + " m",
        ]),
        startY: 75,
        margin: { left: 40, right: 40 },
        styles: { cellPadding: 3, fontSize: 10, valign: "middle" },
        columnStyles: {
          0: { cellWidth: 250 },
          1: { cellWidth: 110, halign: "center" },
          2: { cellWidth: 120, halign: "right" },
        },
      });

      const totalMetros = calcularTotalMetrosPvb();
      let pvbTotalY = pdf.lastAutoTable.finalY + 20;
      const pvbPageH = pdf.internal.pageSize.getHeight();
      if (pvbTotalY > pvbPageH - 30) { pdf.addPage(); pvbTotalY = 40; }
      pdf.setFontSize(12);
      pdf.text(
        `Total PVB consumido: ${totalMetros.toFixed(2)} m lineales`,
        40, pvbTotalY
      );
    }

    setIsLoading(false);  
    // Guardar el PDF
    const fechahoy = dayjs().format('DD-MM-YYYY');
    pdf.save(`Reporte_de_Produccion-${fechahoy}.pdf`);
};
  return (
    <Box
      sx={{
        height: "90vh",
        overflowY: "auto",
        overflowX: "hidden",
        minHeight: "700px",
        padding: { xs: "6px", md: "10px" },
        boxSizing: "border-box",
        "& .MuiDataGrid-root": {
          overflowX: "auto",
          
        },
      }}
    >
      <Box
        sx={{
          display: "flex",
          flexDirection: { xs: "column", md: "row" },
          justifyContent: "space-between",
          alignItems: { xs: "flex-start", md: "center" },
          paddingRight: { xs: "0", md: "50px" },
          gap: { xs: "10px", md: "0" },
        }}
      >
        <Header
          title="Producción del Día"
          subtitle="Clasificación de Laminados"
        />

        <Box sx={{ display: "flex", flexWrap: "nowrap", gap: "4px", alignItems: "center" }}>
          <Button
            sx={{
              background: "#8a1b0d",
              minWidth: "unset",
              width: "42px",
              height: "42px",
              padding: "6px",
              borderRadius: "8px",
              flexShrink: 0,
              "&:hover": {
                background: "#a42410",
              },
            }}
            onClick={handleGenerate}
            variant="contained"
            color="primary"
            title="Exportar PDF"
          >
            <img
              src="https://cdn-icons-png.flaticon.com/512/337/337946.png"
              alt="Exportar PDF"
              style={{ width: 26, height: 26 }}
            />
          </Button>
          <LocalizationProvider dateAdapter={AdapterDayjs}>
            <Box>
              <DatePicker
                label="Inicio"
                value={startDate}
                onChange={(newValue) => setStartDate(dayjs(newValue))}
                format="DD/MM/YYYY"
                slotProps={{
                  textField: {
                    size: "small",
                    sx: {
                      width: "150px",
                      minWidth: "150px",
                      maxWidth: "150px",
                      "@media (max-width:600px)": {
                        width: "120px !important",
                        minWidth: "120px !important",
                        maxWidth: "120px !important",
                      },
                      "& .MuiInputBase-input": {
                        padding: "6px 8px",
                        fontSize: "1rem",
                      },
                      "& .MuiInputLabel-root": {
                        fontSize: "1rem",
                      },
                    },
                  },
                }}
              />
            </Box>
          </LocalizationProvider>
          <LocalizationProvider dateAdapter={AdapterDayjs}>
            <Box>
              <DatePicker
                label="Fin"
                value={endDate}
                onChange={(newValue) => setEndDate(dayjs(newValue))}
                format="DD/MM/YYYY"
                slotProps={{
                  textField: {
                    size: "small",
                    sx: {
                      width: "150px",
                      minWidth: "150px",
                      maxWidth: "150px",
                      "@media (max-width:600px)": {
                        width: "150px !important",
                        minWidth: "150px !important",
                        maxWidth: "150px !important",
                      },
                      "& .MuiInputBase-input": {
                        padding: "6px 8px",
                        fontSize: "1rem",
                      },
                      "& .MuiInputLabel-root": {
                        fontSize: "1rem",
                      },
                    },
                  },
                }}
              />
            </Box>
          </LocalizationProvider>
        </Box>
      </Box>
      <Box
        sx={{
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
          flexWrap: "wrap",
          gap: { xs: "0", md: "10px" },
          width: "100%",
          height: { xs: "auto", md: "100%" },
          margin: "0",
          marginTop: { xs: "10px", md: "-230px" },
          boxSizing: "border-box",
        }}
      >
        <Box height={{ xs: "80vw", md: "45vh" }} width={{ xs: "100%", md: "32%" }} ref={chartRef}>
          <PieChart fecha={elVerdadero} />
        </Box>
        <Box height={{ xs: "80vw", md: "45vh" }} width={{ xs: "100%", md: "32%" }} ref={secondChartRef}>
          <ProduccionPie fecha={elVerdadero} />
        </Box>
        <Box height={{ xs: "80vw", md: "45vh" }} width={{ xs: "100%", md: "32%" }} ref={thirdChartRef}>
          <InterfoliadoTurnoPie fecha={elVerdadero} />
        </Box>
      </Box>
      <Box
        sx={{
          fontFamily: "sans-serif",
          fontSize: { xs: "16px", md: "20px" },
          marginTop: { xs: "12px", md: "-180px" },
          marginBottom: { xs: "8px", md: "14px" },
          zIndex: 100,
        }}
      >
        Total Producido: {calcularTotalProducido()}
      </Box>
      <Box
        height="40vh"
        sx={{
          marginTop: { xs: "8px", md: "12px" },
          marginBottom: { xs: "14px", md: "26px" },
          "& .MuiDataGrid-root": {
            border: "none",
          },
          "& .MuiDataGrid-cell": {
            borderBottom: "none",
          },
          "& .MuiDataGrid-columnHeader, & .MuiDataGrid-cell": {
            px: { xs: 0.5, md: 1.5 },
          },
          "& .MuiDataGrid-columnHeaderTitle": {
            fontSize: { xs: "0.68rem", md: "0.8rem" },
          },
          "& .MuiDataGrid-cellContent": {
            fontSize: { xs: "0.68rem", md: "0.82rem" },
          },
          "& .name-column--cell": {
            color: colors.greenAccent[300],
          },
          "& .MuiDataGrid-columnHeaders": {
            backgroundColor: colors.blueAccent[900],
            borderBottom: "none",
          },
          "& .MuiDataGrid-virtualScroller": {
            backgroundColor: colors.primary[400],
          },
          "& .MuiDataGrid-footerContainer": {
            borderTop: "none",
            backgroundColor: colors.blueAccent[900],
          },
          "& .MuiCheckbox-root": {
            color: `${colors.greenAccent[200]} !important`,
          },
          "& .MuiDataGrid-toolbarContainer .MuiButton-text": {
            color: `${colors.grey[100]} !important`,
          },
        }}
      >
        <DataGrid
          rows={data}
          getRowId={(row) => `${row.id_producto}-${row.turno}-${row.fecha}`}
          columns={columns}
          disableMultipleSelection
        />
      </Box>
      <Box
        sx={{
          fontFamily: "sans-serif",
          fontSize: "20px",
          marginTop: { xs: "10px", md: "22px" },
          marginBottom: { xs: "6px", md: "12px" },
          zIndex: 100,
        }}
      >
        Productos Defectuosos: {calcularTotalDefectos()}
      </Box>

      <Box
        height="40vh"
        sx={{
          marginTop: { xs: "8px", md: "12px" },
          marginBottom: { xs: "14px", md: "26px" },
          "& .MuiDataGrid-root": {
            border: "none",
          },
          "& .MuiDataGrid-cell": {
            borderBottom: "none",
          },
          "& .MuiDataGrid-columnHeader, & .MuiDataGrid-cell": {
            px: { xs: 0.5, md: 1.5 },
          },
          "& .MuiDataGrid-columnHeaderTitle": {
            fontSize: { xs: "0.68rem", md: "0.8rem" },
          },
          "& .MuiDataGrid-cellContent": {
            fontSize: { xs: "0.68rem", md: "0.82rem" },
          },
          "& .name-column--cell": {
            color: colors.greenAccent[300],
          },
          "& .MuiDataGrid-columnHeaders": {
            backgroundColor: colors.blueAccent[900],
            borderBottom: "none",
          },
          "& .MuiDataGrid-virtualScroller": {
            backgroundColor: colors.primary[400],
          },
          "& .MuiDataGrid-footerContainer": {
            borderTop: "none",
            backgroundColor: colors.blueAccent[900],
          },
          "& .MuiCheckbox-root": {
            color: `${colors.greenAccent[200]} !important`,
          },
          "& .MuiDataGrid-toolbarContainer .MuiButton-text": {
            color: `${colors.grey[100]} !important`,
          },
        }}
      >
        <DataGrid
          rows={dataC}
          getRowId={(row) => `${row.id}-${row.turno}`}
          columns={columnsC}
          disableMultipleSelection
        />
      </Box>

      <Box
        sx={{
          fontFamily: "sans-serif",
          fontSize: "20px",
          marginTop: { xs: "10px", md: "22px" },
          marginBottom: { xs: "6px", md: "12px" },
          zIndex: 100,
        }}
      >
        Productos Interfoliados: {calcularTotalInterfoliados()}
      </Box>
      <Box
        height="40vh"
        sx={{
          width: "100%",
          marginTop: { xs: "8px", md: "12px" },
          marginBottom: { xs: "14px", md: "26px" },
          "& .MuiDataGrid-root": {
            border: "none",
            overflow: "hidden",
          },
          "& .MuiDataGrid-cell": {
            borderBottom: "none",
          },
          "& .MuiDataGrid-columnHeader, & .MuiDataGrid-cell": {
            px: { xs: 0.5, md: 1.5 },
          },
          "& .MuiDataGrid-columnHeaderTitle": {
            fontSize: { xs: "0.68rem", md: "0.8rem" },
          },
          "& .MuiDataGrid-cellContent": {
            fontSize: { xs: "0.68rem", md: "0.82rem" },
          },
          "& .name-column--cell": {
            color: colors.greenAccent[300],
          },
          "& .MuiDataGrid-columnHeaders": {
            backgroundColor: colors.blueAccent[900],
            borderBottom: "none",
          },
          "& .MuiDataGrid-virtualScroller": {
            backgroundColor: colors.primary[400],
            overflowX: "auto !important",
            touchAction: "pan-x pan-y",
          },
          "& .MuiDataGrid-footerContainer": {
            borderTop: "none",
            backgroundColor: colors.blueAccent[900],
          },
          "& .MuiCheckbox-root": {
            color: `${colors.greenAccent[200]} !important`,
          },
          "& .MuiDataGrid-toolbarContainer .MuiButton-text": {
            color: `${colors.grey[100]} !important`,
          },
        }}
      >
        <DataGrid
          rows={dataInterfoleacion}
          getRowId={(row) => `${row.id_producto}-${row.clasificacion}-${row.fecha}`}

          columns={columnsI}
          disableMultipleSelection
        />
      </Box>

      {/* --- Sección consumo PVB --- */}
      {calcularResumenPvb().length > 0 && (
        <>
          <Box
            sx={{
              fontFamily: "sans-serif",
              fontSize: "20px",
              marginTop: { xs: "10px", md: "22px" },
              marginBottom: { xs: "6px", md: "12px" },
            }}
          >
            Consumo PVB: {calcularTotalMetrosPvb().toFixed(2)} m lineales
          </Box>
          <Box
            height="30vh"
            sx={{
              marginBottom: { xs: "14px", md: "26px" },
              "& .MuiDataGrid-root": { border: "none" },
              "& .MuiDataGrid-cell": { borderBottom: "none" },
              "& .MuiDataGrid-columnHeaders": { backgroundColor: colors.blueAccent[900], borderBottom: "none" },
              "& .MuiDataGrid-virtualScroller": { backgroundColor: colors.primary[400] },
              "& .MuiDataGrid-footerContainer": { borderTop: "none", backgroundColor: colors.blueAccent[900] },
            }}
          >
            <DataGrid
              rows={calcularResumenPvb()}
              getRowId={(row) => row.pvb_tipo}
              columns={[
                { field: "pvb_tipo", headerName: "Tipo PVB", flex: 2 },
                { field: "cantidad_chapas", headerName: "Chapas producidas", flex: 1, type: "number" },
                {
                  field: "metros_totales",
                  headerName: "Metros lineales",
                  flex: 1,
                  type: "number",
                  valueFormatter: (p) => `${Number(p.value).toFixed(2)} m`,
                },
              ]}
              disableMultipleSelection
              hideFooter
            />
          </Box>
        </>
      )}

      <Box
        sx={{
          display: "flex",
          justifyContent: "flex-end",
        }}
      >
        {/* <Box sx={{ paddingRight: "2%", paddingTop: "0.5%", paddingBottom:"3%" }}>
         <Button sx={{height:"120%"}} type="submit" color="secondary" variant="contained" onClick={handleGenerate}>
            Generar Ticket
          </Button>
        </Box>  */}

        <Box
          sx={{ paddingRight: "2%", paddingTop: "0.5%", paddingBottom: "7%" }}
        >
          {/* <div className="wrap">
            <Button
              className="button-animation"
              type="submit"
              color="secondary"
              variant="contained"
              onClick={handleGenerate}
            >
              Generar Pdf
            </Button>
          </div> */}
        </Box>
      </Box>

      {/* <ProduccionPie 
        fechaSeleccionada={fechaSeleccionada} 
        setFechaSeleccionada={setFechaSeleccionada} 
      /> */}
       <ModalCharge isLoading={isLoading} />
    </Box>
    
  );
  
};

export default RGraficos;